module.exports = __webpack_public_path__ + "static/media/img-unidade-jundiai.63e97bbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/img-unidade-jundiai.jpg
// module id = 743
// module chunks = 0